import type { AvatarPreset } from '@livechat/shared';

import anonymous from './assets/avatars/anonymous.webp';
import catPersianBrown from './assets/avatars/cat-persian-brown.webp';
import dogShihTzuWhite from './assets/avatars/dog-shih-tzu-white.webp';
import manBlack from './assets/avatars/man-black.webp';
import manBlond from './assets/avatars/man-blond.webp';
import manBrown from './assets/avatars/man-brown.webp';
import manBrownHair from './assets/avatars/man-brown-hair.webp';
import manBrunette from './assets/avatars/man-brunette.webp';
import manGinger from './assets/avatars/man-ginger.webp';
import robotHead from './assets/avatars/robot-head.webp';
import womanBlack from './assets/avatars/woman-black.webp';
import womanBlond from './assets/avatars/woman-blond.webp';
import womanBrown from './assets/avatars/woman-brown.webp';
import womanBrunette from './assets/avatars/woman-brunette.webp';
import womanGinger from './assets/avatars/woman-ginger.webp';

export interface AvatarPresetOption {
	id: AvatarPreset;
	label: string;
	src: string;
}

export const avatarPresets: AvatarPresetOption[] = [
	{ id: 'anonymous', label: 'Anonymous person', src: anonymous },
	{ id: 'man-blond', label: 'Man with blond hair', src: manBlond },
	{ id: 'man-brunette', label: 'Man with dark hair', src: manBrunette },
	{ id: 'man-brown-hair', label: 'Clean-shaven man with brown hair', src: manBrownHair },
	{ id: 'man-ginger', label: 'Man with ginger hair', src: manGinger },
	{ id: 'man-brown', label: 'Man with brown skin', src: manBrown },
	{ id: 'man-black', label: 'Black man', src: manBlack },
	{ id: 'woman-blond', label: 'Woman with blond hair', src: womanBlond },
	{ id: 'woman-brunette', label: 'Woman with dark hair', src: womanBrunette },
	{ id: 'woman-brown', label: 'Woman with brown skin', src: womanBrown },
	{ id: 'woman-black', label: 'Black woman', src: womanBlack },
	{ id: 'woman-ginger', label: 'Woman with ginger hair', src: womanGinger },
	{ id: 'cat-persian-brown', label: 'Brown Persian cat', src: catPersianBrown },
	{ id: 'dog-shih-tzu-white', label: 'White Shih Tzu', src: dogShihTzuWhite },
	{ id: 'robot-head', label: 'Friendly robot', src: robotHead },
];

const avatarImages = new Map(avatarPresets.map((preset) => [preset.id, preset.src]));

export function avatarPresetImage(preset: AvatarPreset): string {
	return avatarImages.get(preset) ?? anonymous;
}
